import type { IOrgProjectLocationRepository } from '../repositories/IOrgProjectLocationRepository.js';
import type { OrgLocationEntity } from '../entities/OrgLocationEntity.js';

interface Deps { orgProjectLocationRepository: IOrgProjectLocationRepository; }

export function createListOrgLocationsUseCase({ orgProjectLocationRepository }: Deps) {
  return async function listOrgLocations(orgId: string): Promise<OrgLocationEntity[]> {
    return orgProjectLocationRepository.listByOrg(orgId);
  };
}
